import React from "react";
import "./Notification.css";
import PropTypes from 'prop-types';
import closeImg from "../../../../images/new-images/cancel.png";
import Button from "../../../Utils/Button/index";
import { Link } from "react-router-dom";

const Notification = (props) => {

  const getNotificationStatus = localStorage.getItem("Show Notification");
  const isSignedUp = localStorage.getItem("is_sign_up_completed");
  const successMessage = () => {
    if (!props.successMessage && props.updateMessage) {
      return <p className="notifications-empty">{props.updateMessage}</p>;
    }

    if (props.successMessage === "Reminder sent successfully") {
      return (
        <p className="notifications-empty">
          {props.successMessage} to {props.respondentEmail}
        </p>
      );
    } else if (props.successMessage === "Deleted Successfully") {
      return <p className="notifications-empty">{props.successMessage}</p>;
    } else if (props.notify === true && getNotificationStatus === "true" && isSignedUp === "true") {
      return (
        <React.Fragment>
          <p>Please visit your profile to set it</p>
          <Button type="start">
            <Link to="/new/app/editProfile">Profile</Link>
          </Button>
        </React.Fragment>
      );
    }

    return <div>No Notifications.</div>;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      props.handleCloseNotification();
    }
  };




  return (
    <div className="notification-popover">
      <div className='header'>
        <p className="heading">Notifications</p>
        <button
          onClick={props.handleCloseNotification}
          onKeyDown={handleKeyDown}
          style={{ background: 'none', border: 'none' }}
          aria-label="Close notification"
        >
          <img
            src={closeImg}
            alt=""
          />
        </button>
      </div>
      <hr />
      <div>{successMessage()}</div>
      <hr />

    </div>
  );
};

Notification.propTypes = {
  handleCloseNotification: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  updateMessage: PropTypes.string,
  respondentEmail: PropTypes.string,
  notify: PropTypes.bool,
};


export default Notification;



// WEBPACK FOOTER //
// ./src/new/Components/NavBar/Notification/Notification.jsx